import { FC } from 'react'

import { DndArea } from '@/components/dnd-area/dnd-area.tsx'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { DndCustomProvider } from '@/components/dnd-area/dnd-custom-provider.tsx'

type DndComponentProps = {
  keyArea?: string
  items: RowProps[]
  onReorder?: (newItems: RowProps[]) => void
}

export const DndComponent: FC<DndComponentProps> = ({ items, onReorder, keyArea }) => {
  return (
    <DndCustomProvider>
      <DndArea key={keyArea} items={items} onReorder={onReorder} />
    </DndCustomProvider>
  )
}
